import React, { useState } from "react";
import { Col } from "react-bootstrap";
import style from "../ThemesLayout.module.css";
import AdvanceThemeJson from "./ThemePropertiesJson/AdvanceThemeJson";
import SelectedControlThemeProperties from "./SelectedControlThemeProperties";
import { useDispatch } from "../../../../../Redux";
import { useTranslation } from "react-i18next";
import CustomizedAlert from "../../../../../ReusableComponents/Alert/CustomizedAlert";
import { GetStateFromData } from "../../../../CustomHooks/CustomHooks";
import { updateStateInRedux } from "../../../../../Redux/Actions/FormStateActions";

const AdvanceTheme = (props) => {
  const { t } = useTranslation();
  const advThemeJson = AdvanceThemeJson["controlsList"];
  const dispatch = useDispatch();
  const [selectedControl, setSelectedControl] = useState("Inputs");
  const contexts = GetStateFromData(props.containerId);
  const { formState2, updateJson,showAlertConfirmNotifications} = contexts.contexts;
  const { updatedComponentInFormState } = updateJson;
  var controlThemeData = formState2.theme?.["InputStyle"];
  const isProcessForm = window?.location?.href?.includes("psh/pmWebDesigner")
  const [alertData, setAlertData] = useState({
    open: false,
    showConfirm: "showNotification",
  });
  function handleProperty(propertyKey, propertyValue, propertyName3) {
    let tempCustomSpacing = {}
    var themeKey = advThemeJson[selectedControl].themeKey;
    if (props.selectedTheme && themeKey) {
      if (props.selectedTheme[themeKey]) {
        props.selectedTheme[themeKey][propertyKey] = propertyValue;
      } else {
        props.selectedTheme[themeKey] = {};
        props.selectedTheme[themeKey][propertyKey] = propertyValue;
      }
      var tempThemeVar = { ...props.selectedTheme[themeKey] };

      if (themeKey === "DoclistStyle") {
        dispatch(
          updateStateInRedux({
            name: "doclistRerenderCount",
            value: new Date(),
            key: props.containerId,
          })
        );
      }
      else if (themeKey === "HorizontalTabStyle" )
      { if (propertyValue < 0) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("Entered Value should not be less than 0")}`
        });
        propertyValue = "0";
      }
      else if (propertyValue > 200) {
        showAlertConfirmNotifications({
          open: true,
          showConfirm: "showNotification",
          alertType: "error",
          alertContentKey: `${t("Entered Value should not be greater than 60")}`
        });
        propertyValue = "16px";
       
      }
        if (props.selectedTheme[themeKey]) {
          props.selectedTheme[themeKey][propertyKey] = propertyValue;
          tempCustomSpacing = { ...props.selectedTheme[themeKey]}
        } else {
          props.selectedTheme[themeKey] = {};
          props.selectedTheme[themeKey][propertyKey] = propertyValue;
          tempCustomSpacing = { ...props.selectedTheme[themeKey]}
        }
        
      }
      if(Object.keys(tempCustomSpacing).length !==0){
        props.selectedTheme[themeKey]=tempCustomSpacing
      }

      var tempThemeVar = { ...props.selectedTheme[themeKey] };
      props.selectedTheme[themeKey] = tempThemeVar;
      props.showThemechanges(props.selectedTheme);
    }
  }
  function leftRightAlignmentApply() {
    formState2.theme["InputStyle"].ControlStyleTextbox = "Style1";
    updatedComponentInFormState();
  }

  function leftRightAlignmentNotApply() {
    formState2.theme["InputStyle"].LabelValueAlignment = "Top Bottom";
    updatedComponentInFormState();
  }

  if (
    !alertData?.open &&
    controlThemeData?.ControlStyleTextbox?.toLowerCase() === "style3" &&
    controlThemeData?.LabelValueAlignment === "Left Right"
  ) {
    setAlertData({
      open: true,
      showConfirm: "showconformationDialogBox",
      alertContentKey: `${t(
        "The input style for basic inputs will be changed to Style 1 if you would like to use left-Right alignment, since Left-Right alignment is not available for Style 3."
      )}`,
      alertTitleKey: `${t(
        "Left - right alignment is NOT available for style 3."
      )}`,
      Button1Key: `${t("Cancel")}`,
      Button2Key: `${t("Change to style 1")}`,
      leftRightAlignmentApply: leftRightAlignmentApply,
      leftRightAlignmentNotApply: leftRightAlignmentNotApply,
    });
  }

  return (
    <div className={style.themeRoot} style={{height:isProcessForm ? `calc(100vh - 56px - ${props?.headerHeight}px)` : `calc(100vh - 48px - 56px - ${props?.headerHeight}px)`,overflow:"unset"}}>
      <Col
        className={["col", style.advanceThemeControlOptions].join(" ")}
        style={{ paddingRight: "0px !important" }}
      >
        {AdvanceThemeJson && AdvanceThemeJson["controlsList"] ? (
          Object.keys(AdvanceThemeJson["controlsList"]).map(
            (control, index) => {
              return (
                control !== "Application" && (
                  <div
                    tabIndex={0}
                    className={[
                      style.advanceThemeControl,
                      selectedControl === control
                        ? style.selectedStyleImgDiv
                        : null,
                    ].join(" ")}
                    onClick={() => setSelectedControl(control)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        setSelectedControl(control);
                      }
                    }}
                  >
                    <Col
                      className={style.advanceThemeSquareBoxParent}
                      onClick={() => setSelectedControl(control)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setSelectedControl(control);
                        }
                      }}
                    >
                      <img
                        src={
                          (
                            AdvanceThemeJson["controlsList"] &&
                            AdvanceThemeJson["controlsList"][control] &&
                            AdvanceThemeJson?.["controlsList"]?.[control]?.[
                              "imgSrc"
                            ] &&
                            AdvanceThemeJson?.["controlsList"]?.[control]?.[
                              "imgSrc"
                            ]
                          ).default
                        }
                        className={[style.squareBoxIconTheme].join("")}
                        alt="Square Box Icon"
                      />
                    </Col>
                    <Col
                      className={[
                        style.advanceThemeControlName,
                        selectedControl === control ? style.selectedText : null,
                      ].join(" ")}
                      onClick={() => setSelectedControl(control)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          setSelectedControl(control);
                        }
                      }}
                    >
                      {t(`${control}`)}
                    </Col>
                  </div>
                )
              );
            }
          )
        ) : (
          <></>
        )}
      </Col>
      <Col
        className={[
          "col-sm-12",
          style.advanceThemeControlThemeDescription,
        ].join(" ")}
      >
        <SelectedControlThemeProperties
          key={selectedControl}
          selectedControl={selectedControl}
          selectedTheme={props.selectedTheme}
          themeKey={
            advThemeJson &&
            advThemeJson[selectedControl] &&
            advThemeJson[selectedControl].themeKey
          }
          handleProperty={(arg1, arg2) => handleProperty(arg1, arg2)}
        />
      </Col>
      {alertData.open === true && <CustomizedAlert alertData={alertData} />}
    </div>
  );
};

export default AdvanceTheme;
